module.exports = __webpack_public_path__ + "img/2716.cee60494.svg";